<life-di-nav></life-di-nav>

<!-- screen user -->

<mat-spinner *ngIf="!homeInfo" class="spinner-center"></mat-spinner>
<div
  *ngIf="homeInfo && token === '' || homeInfo && role === 'user' && !isTA || homeInfo && role === 'admin' && byPass || homeInfo && role === 'psychologist' && byPass || homeInfo && role === 'teacher' && byPass || homeInfo && role === 'user' && isTA && byPass">
  <div class="container-fulid">
    <ngb-carousel #carousel [interval]="5000">
      <ng-template ngbSlide *ngFor="let banner of homeInfo?.banner; index as i">
        <div class="picsum-img-wrapper">
          <img [src]="banner.BANNER_PIC" class="bannerWidth centerImg">
        </div>
      </ng-template>
    </ngb-carousel>
  </div><br />
  <div *ngIf="role === 'admin' || role === 'teacher' || role === 'psychologist' || role === 'user' && isTA"
    style="padding-bottom: 50px;">
    <div style="position: absolute; right: 2%;">
      <lifedi-btn customStyle="padding: 0 20px; background: #060E9F; color: #fff" lable="ไปหน้าจัดการ"
        (click)="clickByPass()">
      </lifedi-btn>
    </div>
  </div>
  <div class="row d-none">
    <h1>ข่าวสาร บทความ คอร์สเรียน consult workshop แบบทดสอบ วิจัย</h1>
  </div>
  <div class="container mt-4">
    <div>
      <h2 class="lifedi-color" style="display: inline-block;">ข่าวสาร</h2>
      <a routerLink="/news" style="margin-top: 15px; float: right;">ดูข่าวสารทั้งหมด</a>
    </div>
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let item of homeInfo?.news">
        <ng-template carouselSlide>
          <lifedi-card-box [routerLink]="item.NEWS_ID ? ['news', item.NEWS_ID] : []" [title]="item.NEWS_TITAL"
            [imageUrl]="item.NEWS_PIC" [content]="item.NEWS_DETAIL" [date]="item.NEWS_DATE" [id]="item.NEWS_ID">
          </lifedi-card-box>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div><br />

  <div class="container mt-4">
    <div>
      <h2 class="lifedi-color" style="display: inline-block;">คอร์สเรียน</h2>
      <a routerLink="/e-learning" style="margin-top: 15px; float: right;">ดูคอร์สเรียนทั้งหมด</a>
    </div>
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let c of homeInfo.course">
        <ng-template *ngIf="!c.COURSE_NAME" carouselSlide>
          <lifedi-course-card [imageUrl]="c.COURSE_PIC" [haveFavorite]="false">
          </lifedi-course-card>
        </ng-template>
        <ng-template *ngIf="c.COURSE_NAME" carouselSlide>
          <lifedi-course-card [routerLink]="c.COURSE_ID ? ['e-learning', c.COURSE_ID] : []" [title]="c.COURSE_NAME"
            [imageUrl]="c.COURSE_PIC" [haveFavorite]="false" [teacherName]="c.TEACHER.USERNAME" [price]="c.COURSE_PRICE"
            [premiumPrice]="c.COURSE_SPECIALPRICE" [isPremium]="homeInfo.IS_PREMIUM">
          </lifedi-course-card>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div><br />

  <div class="container mt-4">
    <div>
      <h2 class="lifedi-color" style="display: inline-block;">บทความ</h2>
      <a routerLink="/article" style="margin-top: 15px; float: right; display: inline-block;">ดูบทความทั้งหมด</a>
    </div>
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let item of homeInfo?.artical">
        <ng-template carouselSlide>
          <lifedi-card-box [routerLink]="item.ARTICAL_ID ? ['article', item.ARTICAL_ID] : []"
            [title]="item.ARTICAL_TITAL" [imageUrl]="item.ARTICAL_PIC" [content]="item.ARTICAL_DETAIL"
            [id]="item.ARTICAL_ID"></lifedi-card-box>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div><br />
</div>
<!-- screen user -->


<!-- screen admin -->
<div *ngIf="role === 'admin' && !byPass">
  <div style="position: absolute; right: 2%; padding-top: 10px;">
    <lifedi-btn customStyle="padding: 0 20px; background: #060E9F; color: #fff; z-index: 500;" lable="ไปหน้า Home"
      (click)="clickByPass()">
    </lifedi-btn>
  </div>
  <div class="container text-center" style="padding-top: 30px;">
    <owl-carousel-o [options]="homeAdminOptions">
      <ng-template carouselSlide *ngFor="let item of adminList1[0]; let i = index">
        <div class="row">
          <lifedi-icon-home [imageUrl]="item.imgUrl" [title]="item.title" [link]="item.link"></lifedi-icon-home>
          <lifedi-icon-home [imageUrl]="adminList1[1][i].imgUrl" [title]="adminList1[1][i].title"
            [link]="adminList1[1][i].link">
          </lifedi-icon-home>
        </div>
      </ng-template>
      <ng-template carouselSlide *ngFor="let item2 of adminList2[0]; let j = index">
        <div class="row">
          <lifedi-icon-home [imageUrl]="item2.imgUrl" [title]="item2.title" [link]="item2.link"></lifedi-icon-home>
          <lifedi-icon-home *ngIf="j === 0 || j === 1" [imageUrl]="adminList2[1][j].imgUrl" [title]="adminList2[1][j].title"
            [link]="adminList2[1][j].link">
          </lifedi-icon-home><!-- เอา j === 0 || j === 1 ได้ ถ้า index 0 กับ 1 เท่ากัน === -->
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
<!-- screen admin -->


<!-- screen teacher -->
<div *ngIf="role === 'teacher' && !byPass">
  <div style="position: absolute; right: 2%; padding-top: 10px;">
    <lifedi-btn customStyle="padding: 0 20px; background: #060E9F; color: #fff; z-index: 500;" lable="ไปหน้า Home"
      (click)="clickByPass()">
    </lifedi-btn>
  </div>
  <div class="container text-center" style="padding-top: 30px;">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 col-xs-1" *ngFor="let item of teacherList">
        <lifedi-icon-home [imageUrl]="item.imgUrl" [title]="item.title" [link]="item.link"></lifedi-icon-home>
      </div>
    </div>
  </div>
</div>
<!-- screen teacher -->


<!-- screen psychologist -->
<div *ngIf="role === 'psychologist' && !byPass">
  <div style="position: absolute; right: 2%; padding-top: 10px;">
    <lifedi-btn customStyle="padding: 0 20px; background: #060E9F; color: #fff; z-index: 500;" lable="ไปหน้า Home"
      (click)="clickByPass()">
    </lifedi-btn>
  </div>
  <div class="container text-center" style="padding-top: 80px;">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-1" *ngFor="let item of psychologistList">
        <lifedi-icon-home [imageUrl]="item.imgUrl" [title]="item.title" [link]="item.link"></lifedi-icon-home>
      </div>
    </div>
  </div>
</div>
<!-- screen psychologist -->


<!-- screen TA -->
<div *ngIf="role === 'user' && !byPass && isTA">
  <div style="position: absolute; right: 2%; padding-top: 10px;">
    <lifedi-btn customStyle="padding: 0 20px; background: #060E9F; color: #fff; z-index: 500;" lable="ไปหน้า Home"
      (click)="clickByPass()">
    </lifedi-btn>
  </div>
  <div class="container text-center" style="padding-top: 80px;">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-1" *ngFor="let item of TAList">
        <lifedi-icon-home [imageUrl]="item.imgUrl" [title]="item.title" [link]="item.link"></lifedi-icon-home>
      </div>
    </div>
  </div>
</div>
<!-- screen TA -->

<lifedi-footer
  *ngIf="homeInfo && token === '' || homeInfo && role === 'user' && !isTA || homeInfo && role === 'admin' && byPass || homeInfo && role === 'psychologist' && byPass || homeInfo && role === 'teacher' && byPass || homeInfo && role === 'user' && isTA && byPass">
</lifedi-footer>